import React, { useEffect } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import { useParams, useLocation } from "react-router-dom";
import { matchPath } from "react-router";
import { routes } from '~/helpers/routeHelper';
import ContactDesktop from "./Desktop";
import ContactMobile from "./Mobile";
import { useAppDispatch, useAppSelector } from "~/hooks/redux";
import { getOrder } from "~/store/actions";
import { getNotaryBid } from "~/store/actions";
import { showError } from "~/helpers/utilHelper";

const Contact = () => {
  // get order id from url
  const { id: idParam } = useParams<{ id?: string }>();
  const id = idParam ? parseInt(idParam) : 0;

  // redux hook that dispatches actions
  const dispatch = useAppDispatch();

  const location = useLocation();

  const order = useAppSelector(state => state.Order.Single.order);
  const orderError = useAppSelector(state => state.Order.Single.orderError);
  const notaryBid = useAppSelector(state => state.NotaryBid.Single.notaryBid);

  useEffect(() => {
    const showRoute = !!matchPath({ path: routes.view_notary_bid }, location.pathname);
    if (showRoute) {
      if (!notaryBid) {
        dispatch(getNotaryBid(id));
      }
    } else {
      dispatch(getOrder(id));
    }
  }, [id, dispatch, location.pathname, notaryBid]);

  useEffect(() => {
    if (orderError) {
      showError("Unable to contact");
    }
  }, [orderError]);

  return (
    <React.Fragment>
      {(order || notaryBid) && (
        <>
          <BrowserView>
            <ContactDesktop />
          </BrowserView>
          <MobileView>
            <ContactMobile />
          </MobileView>
        </>
      )}
    </React.Fragment>
  );
};

export default Contact;